import { genericPage, getServerSidePropsHelper, getMappingEleccions3CatInfo, getSlugEleccio } from 'components/3catinfo/Page';
import { useRouter } from 'next/router';

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions']);
};

export async function getServerSideProps(context) {
    const slugEleccio = getSlugEleccio(context?.resolvedUrl);
    const mapping = await getMappingEleccions3CatInfo(slugEleccio);
    const path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions', slugEleccio, 'on-han-votat-mes-a-cada-partit'];

    const options = {
        slugs: path,
        id: mapping.id,
        slugEleccio
    };
    return getServerSidePropsHelper(context, options);
}

export default Pagina;
